import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfigService } from '../../app-config.service';

export const PIDS_THAT_WILL_NOT_SEE_PRODUCTS_PAGE = [
  'RDVR',
  'L9MK',
  'DRFT',
  'LXMB',
  'QYPU',
  'STCX',
  'BRAG',
  'GALS',
  'JAHD',
];

@Injectable({ providedIn: 'root' })
export class AccessTrainingResourcesPageGuard {
  constructor(
    private readonly router: Router,
    private readonly configService: AppConfigService,
  ) {}

  canActivate(): boolean | UrlTree {
    const pid = this.configService.config.partnerId;
    return this.canAccessProductsPage(pid) ? true : this.router.createUrlTree(['/access-denied']);
  }

  canAccessProductsPage = (pid: string): boolean => {
    return !PIDS_THAT_WILL_NOT_SEE_PRODUCTS_PAGE.includes(pid);
  };
}
